import { useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@utils';

export const useCustomsSync = () => {
  const queryClient = useQueryClient();

  return apiClient.customsNotifications.customsSync.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['admin-customs-notifications'],
      });
    },
  });
};
